<template>
	<div class="inner-box" v-cloak>
		<div class="detail-social-block">
			<div class="back-link">
				<a href="../list.html" class="link">Full List of Films</a>
			</div>
			<div class="next-link">
				<router-link v-if="film.prev" :to="{ name : 'filmenrouter', params : { id: film.prev.film_identifier }}" class="link">&lt; Previous</router-link>
				<span class="separator">　|　</span>
				<router-link v-if="film.next" :to="{ name : 'filmenrouter', params : { id: film.next.film_identifier }}" class="link">Next &gt;</router-link>
			</div>
			<ul class="social-buttons _pc">
				<li class="like">
					<iframe :key="'fb1_' + film.film_identifier" :src="'https://www.facebook.com/plugins/like.php?href=https://2026.tiff-jp.net/en/lineup/film/' + film.film_identifier + '&layout=button&action=like&size=small&show_faces=false&share=false'" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:72px; height:21px;" allowTransparency="true"></iframe>
				</li>
				<Tweet v-if="showTweet" :url="'https://2026.tiff-jp.net/en/lineup/film/' + film.film_identifier" :lang="'en'" :text="'【' + film.title_en + '】｜39th Tokyo International Film Festival #39thTokyoInternationalFilmFestival #TIFFJP #eiga'"></Tweet>
				<li v-if="showTweet" class="line">
					<span>
						<div class="line-it-button" data-lang="en" data-type="share-a" style="display: none;"></div>
					</span>
				</li>
			</ul>
		</div>

		<div class="detail-masonry">
			<div class="detail-movie-info-1 masonry-item -main">
				<ul class="categories">
					<li class="category -main" v-if="film.department">
            <span>{{film.department.name_en}}</span>
          </li>
					<li class="category" v-if="film.department_subtitle_en">{{film.department_subtitle_en}}</li>
					<li class="category" v-if="film.title_head_en">{{film.title_head_en}}</li>
				</ul>
				<div class="subject" v-if="film.title_en">{{film.title_en}}</div>
				<div class="subject -english" v-if="film.original_title"><span class="original">[{{film.original_title}}]</span></div>
				<div class="director" v-if="film.director_en">Director:{{film.director_en}}<span class="original" v-show="film.director_original">[{{film.director_original}}]</span></div>
				<ul class="genre-list">
					<li v-if="film.is_genre_human_drama" class="genre -human">Drama</li>
					<li v-if="film.is_genre_comedy" class="genre -comedy">Comedy</li>
					<li v-if="film.is_genre_love_story" class="genre -romance">Romance</li>
					<li v-if="film.is_genre_action" class="genre -action">Action</li>
					<li v-if="film.is_genre_horror" class="genre -horror">Horror</li>
					<li v-if="film.is_genre_suspense" class="genre -suspense">Suspense</li>
					<li v-if="film.is_genre_sf_fantasy" class="genre -sf-fantasy">Science Fiction/Fantasy</li>
					<li v-if="film.is_genre_youth" class="genre -youth-drama">Youth Drama</li>
					<li v-if="film.is_genre_music" class="genre -music">Music</li>
					<li v-if="film.is_genre_eros" class="genre -eros">Erotic Drama</li>
					<li v-if="film.is_genre_documentary" class="genre -documentary">Documentary</li>
					<li v-if="film.is_genre_animation" class="genre -animation">Animation</li>
				</ul>
				<div class="premiere">{{film.premier_en}}</div>
				<div class="lang-link"><a :href="'/ja/lineup/film/' + film.film_identifier">&gt; Japanese</a></div>

        <Slider v-if="showSlide" :loaded="loaded" :film="film" @slideImageLoaded="slideImageLoaded"></Slider>

				<div class="meta">{{film.copyrights_en}}</div>

				<ul class="social-buttons _sp">
					<li class="like">
						<iframe :key="'fb2_' + film.film_identifier" :src="'https://www.facebook.com/plugins/like.php?href=https://2026.tiff-jp.net/en/lineup/film/' + film.film_identifier + '&layout=button&action=like&size=small&show_faces=false&share=false'" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:72px; height:21px;" allowTransparency="true"></iframe>
					</li>
					<Tweet v-if="showTweet" :url="'https://2026.tiff-jp.net/en/lineup/film/' + film.film_identifier" :lang="'en'" :text="'【' + film.title_en + '】｜39th Tokyo International Film Festival #39thTokyoInternationalFilmFestival #TIFFJP #eiga'"></Tweet>
					<li v-if="showTweet" class="line">
						<span>
							<div class="line-it-button" data-lang="en" data-type="share-a" style="display: none;"></div>
						</span>
					</li>
				</ul>

				<div v-if="film.is_report_link_en" class="news_link"><a :href="'http://2026.tiff-jp.net/news/en/?tag=' + film.film_identifier">&raquo;Read articles</a></div>
				<div class="caution-2 pre-br" v-if="film.film_guide_bk_en" v-html="film.film_guide_bk_en"></div>
				<div class="caution-1 pre-br" v-if="film.film_guide_red_en" v-html="film.film_guide_red_en"></div>

			</div>

			<div class="detail-schedule masonry-item -sub">
				<div class="title">Schedule & Ticket</div>
				<div class="body">
          <div v-if="ticketAlart" v-html="ticketAlart"></div>
					<div class="unit" v-for="act in film.acts" :key="act.id">
						<div class="theater">{{act.venue.name_en}}</div>
						<div class="show">
							<span v-if="act.act_date" class="date">{{act.act_date | dateformat}}</span>
							<span v-if="act.act_date" class="week">[{{act.act_date | dayformat}}]</span>
							<span v-if="act.open_at" class="time">{{act.open_at | timeformat}}-</span>
							<span class="running-time">（{{film.film_time_length}}min）</span>
              <span v-if="act.ticket_status == 3" class="seat -status-1">◎</span>
              <span v-if="act.ticket_status == 2" class="seat -status-2">△</span>
              <span v-if="act.ticket_status == 1" class="seat -status-3">✕</span>
              <span v-if="act.ticket_status == 0" class="seat">-</span>
						</div>
						<ul class="categories">
							<li v-if="act.is_event_qa" class="category -qanda">Q&amp;A</li>
							<li v-if="act.is_event_sa" class="category -greeting">Stage Greeting</li>
							<li v-if="act.is_event_ts" class="category -talkshow">Talk show</li>
							<li v-if="act.is_event_award" class="category -award-ceremony">Award Ceremony</li>
							<li v-if="act.is_event_event" class="category -event">Online Event</li>
						</ul>
						<div class="guest pre-br" v-if="act.guest_en" v-html="act.guest_en"></div>
						<div class="caution pre-br" v-if="act.guest_guide_en" v-html="act.guest_guide_en"></div>
						<div class="price">
              <span class="price_main" v-if="act.ticket_price_en" v-html="act.ticket_price_en"></span>
              <div class="note" v-if="act.ticket_price_s_en" v-html="act.ticket_price_s_en"></div>
						</div>
						<div class="price">
							<span v-if="act.is_show_flag_free" class="price_main">Free admission</span>
							<span v-if="act.is_show_flag_advanced" class="preceding-lottery">TIFF TALK SALON</span>
							<span v-if="act.is_show_flag_application" class="pre-registration">Advance application</span>
							<div v-if="act.is_show_flag_end" class="cut-off">Closed</div>
						</div>
						<div class="accepted-method pre-br" v-if="act.application_method_en" v-html="act.application_method_en"></div>
						<div class="guide-note1 pre-br" v-if="act.guide_bk_en" v-html="act.guide_bk_en"></div>
						<div class="guide-note2 pre-br" v-if="act.guide_rd_en" v-html="act.guide_rd_en"></div>
						<div v-if="act.saling_status == 2" class="button">
              <a :href="ticketPath + act.sales_identifier + '?language=en'" data-category="Films-en" data-action="click" :data-label="film.film_identifier +' '+ act.act_date +' '+ act.open_at" class="link" target="_blank">Go to Online Ticket Site</a>
            </div>
						<div v-if="act.saling_status == 1" class="button -disabled">Go to Online Ticket Site</div>
					</div>

          <!--not show on 2025-->
					<!-- <div v-if="film.is_show_seats" class="ticket_important important2">
						<div class="hl">Situation of seats</div>
						<div class="icon_info">
							<span class="seat -status-1">◎</span>：Still seats available
							<span class="seat -status-2">△</span>：Only few seats left
							<span class="seat -status-3">✕</span>：Tickets are sold out
						</div>
						<div class="note">* Tickets for some screenings/programs may be available again after sold-out.</div>
						<div class="news qa"></div>
					</div> -->
          <!-- end not show on 2025 -->

          <div v-if="ticketLink" v-html="ticketLink"></div>

          <div v-if="film.acts && film.acts.length" class="notes">
						<div class="note -no4">Tax included.</div>
						<div class="note -no1">Please note that the stage appearances of guests and scheduled time of the show may change according to circumstances.</div>
					</div>
				</div>
			</div>

			<div class="detail-movie-info-2 masonry-item -main">
				<div v-if="film.abstract_en">
					<div class="title">Synopsis</div>
					<div class="text pre-br" omit-tag="true" v-html="film.abstract_en"></div>
				</div>
				<div v-if="film.exp_en">
					<div class="title">Introduction</div>
					<div class="text pre-br" omit-tag="true" v-html="film.exp_en"></div>
				</div>
				<div class="title">Data</div>
				<table class="about">
					<tr v-if="film.director_en">
						<th>Director</th>
						<td>{{film.director_en}}
              <span class="original" v-show="film.director_original">[{{film.director_original}}]</span>
							<p class="biography pre-br" v-html="film.director_profile_en"></p>
						</td>
					</tr>
          <tr v-if="film.staffs && film.staffs.length">
						<th>Staff</th>
						<td>
							<p v-for="s in film.staffs" :key="s.id" v-show="s.name_en">
								{{s.position_en}}：{{s.name_en}}
							</p>
						</td>
					</tr>
					<tr v-if="film.performers && film.performers.length">
						<th>Cast</th>
						<td>
							<p v-for="c in film.performers" :key="c.id">
								{{c.name_en}}
							</p>
						</td>
					</tr>
					<tr v-if="film.url || film.facebook || film.twitter || film.instagram">
						<th>Links</th>
						<td>
							<ul>
								<li v-if="film.url" class="site"><a :href="film.url" target="_blank">{{film.sitename_en}}</a></li>
								<li v-if="film.facebook" class="sns"><a :href="film.facebook" target="_blank"><img src="/img/lineup/sns_facebook.png" alt=""></a></li>
								<li v-if="film.twitter" class="sns"><a :href="film.twitter" target="_blank"><img src="/img/lineup/sns_twitter.png" alt=""></a></li>
								<li v-if="film.instagram" class="sns"><a :href="film.instagram" target="_blank"><img src="/img/lineup/sns_instagram.png" alt=""></a></li>
							</ul>
						</td>
					</tr>
				</table>
				<ul class="meta">
					<li v-if="film.film_time_length">{{film.film_time_length}}min</li>
					<li v-if="film.color_en">{{film.color_en}}</li>
					<li v-if="film.film_lang_en">{{film.film_lang_en}}</li>
					<li v-if="film.acts && film.acts.length">{{film.acts[0].subtitle_en}}</li>
					<li v-if="film.made_year">{{film.made_year}}</li>
					<li v-if="film.made_in_en">{{film.made_in_en}}</li>
					<li v-if="film.company_en" v-html="film.company_en"></li>
				</ul>
				<div class="pagetop"><a href="#pagetop">↑page top</a></div>
				<div class="others-link">
					<div class="hl">Other Line-ups</div>
					<div class="body">
						<div v-if="film.prev" class="work-left"><router-link :to="{ name : 'filmenrouter', params : { id: film.prev.film_identifier }}">
							<div class="maincut"><img :src="'/img/lineup/cut/' + film.prev.film_identifier + '_1.jpg'" alt=""></div>
							<div class="category">{{film.prev.department.name_en}}</div>
							<div class="subject">{{film.prev.title_en}}</div>
							<div class="meta">{{film.prev.copyrights_en}}</div>
						</router-link></div>
						<div v-if="film.next" class="work-right"><router-link :to="{ name : 'filmenrouter', params : { id: film.next.film_identifier }}">
							<div class="maincut"><img :src="'/img/lineup/cut/' + film.next.film_identifier + '_1.jpg'" alt=""></div>
							<div class="category">{{film.next.department.name_en}}</div>
							<div class="subject">{{film.next.title_en}}</div>
							<div class="meta">{{film.next.copyrights_en}}</div>
						</router-link></div>
					</div>
				</div>
			</div>

      <div v-if="ticketInfo" v-html="ticketInfo"></div>

			<div class="footer _sp"><div class="pagetop"><a href="#pagetop">↑Pagetop</a></div></div>
		</div>

  </div>
</template>

<style scoped>
  .v-cloak ,
  [v-cloak] {
    visibility:hidden;
  }
  .pre-br {
    white-space: pre-wrap;
  }
</style>

<script>

import axios from 'axios'
import film from '../mixins/film'
import {apiEnv} from '../env.js'

var apiPath = apiEnv()

export default {
  name: 'FilmEn',
  mixins: [film],
  methods: {
		redirectList () {
			document.location = "/en/lineup/list.html"
		},
		insertMeta (data) {
			document.title = '【'+data.data.title_en+'】 | 39th Tokyo International Film Festival'
		}
  },
  created () {
    axios
      .get('/en/include/lineup_ticket_alart.inc')
      .then((res) => {
        this.ticketAlart = res.data
      })
    axios
      .get('/en/include/lineup_ticket_info.inc')
      .then((res) => {
        this.ticketInfo = res.data
      })
    axios
      .get('/en/include/ticket_link.inc')
      .then((res) => {
        this.ticketLink = res.data
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/FilmEn.vue